import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'stockholm-sun-svg-icon',
    templateUrl: 'stockholm-sun-svg-icon.component.html',
    standalone: false
})

export class StockholmSunSvgIconComponent implements OnInit {
  constructor() { }

  ngOnInit() { }
}
